<template>
</template>

<script>

import AlertPopup from '@/components/AlertPopup.vue';
import LoadingIndicator from '@/components/viewer/LoadingIndicator.vue';
import axios from 'axios';
import { Zlib } from 'zlibjs/bin/unzip.min';
import Modes from '../assets/javascripts/misc/Modes';

const storageRoot = 'https://storage.emarf.co';
const report = (process.env.NODE_ENV !== 'development');

const apiRoot = (
  (process.env.API_ENV === 'development') ? 'https://dev-cam.emarf.co'
    : (process.env.API_ENV === 'lab') ? 'https://cam-lab.emarf.co'
      : 'https://cam.emarf.co'
);

export default {
  name: 'PageBase',
  components: {
    AlertPopup,
    LoadingIndicator
  },
  controller: undefined, // this.$options.controller
  data () {
    return {
      cnc: true,
      storageRoot,
      apiRoot,
      report,
      isLoading: false,
      Modes,
      baseUrl: '/',
      sbp: null
    };
  },
  mounted () {
  },
  beforeDestroy () {
    if (this.$options.controller !== undefined) {
      this.$options.controller.destroy();
    }
  },
  methods: {
    setupPopups (popups) {
      popups.forEach(popup => {
        popup.$on('show', (cur) => {
          popups.filter(other => other !== cur).forEach(other => {
            other.hide();
          });
        });
      });
    },
    displayAlert (message, contact = undefined, errors = []) {
      this.$refs.AlertPopup.message = message;
      this.$refs.AlertPopup.contact = (contact !== undefined) ? contact : false;
      this.$refs.AlertPopup.errors = errors;

      // if the message is written in English, it is seen as '不明なエラー'
      this.$refs.AlertPopup.unknownErrorExist = (message.split(' ').length != 1 && /^[a-zA-Z]+$/.test(message.split(' ')[0])) ? true : false;
      this.$refs.AlertPopup.show();
    },
    download (url, name) {
      let a = document.createElement('a');
      let e = document.createEvent('MouseEvent');
      a.download = name;
      a.href = url;
      e.initEvent('click', true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 0, null);
      a.dispatchEvent(e);
    },
    getStorageUrl (folder, path) {
      return `${this.storageRoot}/${folder}/${path}`;
    },
    async unzip (url) {
      const { data } = await axios.get(url, { responseType: 'arraybuffer' });
      const unzip = new Zlib.Unzip(Buffer.from(data));
      const filenames = unzip.getFilenames();
      return filenames.map(name => {
        const sbp = Buffer.from(unzip.decompress(name)).toString();
        return { name, sbp };
      });
    }
  }
};

</script>

<style lang='scss'>

@import '../assets/styles/normalize.css';
@import '../assets/styles/inputrange.scss';
@import '../assets/styles/main.scss';

</style>



// WEBPACK FOOTER //
// src/pages/PageBase.vue